// import i18n, { getLanguage } from '@/lang'
import Cookies from 'js-cookie'
// import axios from '@/axios'

// 要设置的全局访问的state对象
const state = {
  language: Cookies.get('language') || 'zh_CN', // 中英文
  retailinkMenuHighLight: Cookies.get('retailinkMenuHighLight') || '', // 当前菜单key
  retailinkMenuTitle: Cookies.get('retailinkMenuTitle') || '', // 当前菜单key
  token: Cookies.get('token') || '', // 用户token
  account: Cookies.get('account') || '', // 用户account
  roleCode: Cookies.get('retailink-roleCode') || '', // 用户roleCode
  isAdmin: Cookies.get('isAdmin') || '', // 用户是否是admin
  isOthers: Cookies.get('isOthers') || '', // 用户是否是others
  isHead: Cookies.get('isHead') || '', // 用户是否是HEADQUARTER
  avatar: Cookies.get('avatar') || '', // 用户头像
  areaList: [], // 区域列表
  provinceList: [], // 省份列表
  cityList: [], // 城市列表
  resellerList: [], // 客户列表
  subResellerList: [], // 二级客户列表
  KeyDoorList: [], // iskeydoor列表
  courseClassList: [], // 品类列表
  roleList: [], // 角色列表
  statusList: [], // 状态列表
  checkItemList: [], // 检查项列表
  doorTypeList: [], // 门店类型列表
}

// 处理同步
const mutations = {
  setToken (state, token) {
    state.token = token
    Cookies.set('token', token)
  },
  setAccount (state, account) {
    state.account = account
    Cookies.set('account', account)
  },
  setAvatar(state, avatar) {
    state.avatar = avatar;
    Cookies.set('avatar', avatar)
  },
  setRoleCode (state, roleCode) {
    state.roleCode = roleCode
    Cookies.set('retailink-roleCode', roleCode)
    console.log('retailink-roleCode', roleCode)
    console.log('retailink-roleCode', state.roleCode)
  },
  setLanguage (state, lang) {
    state.language = lang
    Cookies.set('language', lang)
  },
  setAdmin (state, bool) {
    state.isAdmin = bool
    Cookies.set('isAdmin', bool)
  },
  setOthers (state, bool) {
    state.isOthers = bool
    Cookies.set('isOthers', bool)
  },
  setHead (state, bool) {
    state.isHead = bool
    Cookies.set('isHead', bool)
  },
  setMenuTitle(state, title) {
    state.retailinkMenuTitle = title;
    Cookies.set('retailinkMenuTitle', title)
  },
  setMenuHighLight(state, title) {
    state.retailinkMenuHighLight = title;
    Cookies.set('retailinkMenuHighLight', title)
  },
  
}

// 处理异步
const actions = {
  async getStoreCheckItems({ state }) { // 检查项
      let res = await axios.post(oprReqUrl+"checkitem/search", {});
      res = res.data
      if (res.code === 200) state.checkItemList = res.data.list || [];
  },
  async getDoorTypeList({ state }) { // 门店类型
      let res = await axios.post(oprReqUrl+"door/conceptlist", {});
      res = res.data
      if (res.code === 200) state.doorTypeList = res.data || [];
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js